import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import {
    Button, Menu,
    MenuItem
} from '@mui/material';
import api from "../../configs/api"
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import dayjs from 'dayjs';
import { Backdrop, CircularProgress } from '@mui/material';
import axios from 'axios';
const ExelProduct = ({ product, warehouse, dataAPIEndPoint, selectBrand, selectProductType, selectStocks, name }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [loading, setLoading] = useState(false);
    const open = Boolean(anchorEl);
    console.log("selectBrand", selectBrand);
    const [listData, setListData] = useState([])
    console.log("ListData", listData);
    const searchParam = new URLSearchParams({ name: '', page: 1, size: 1000, statusDocText: 'ALL', sortExportBill: 'ASC', selectProductType, selectBrand });

    //console.log("fetchProductTransactions", fetchProductTransactions());
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleExportListAll = async () => {
        setLoading(true); // แสดง loading spinner
        try {
            const payload = {
                name: name || '',
                selectProductType: selectProductType?._id || '',
                selectBrand: selectBrand?._id || '',
                selectStocks: selectStocks || "",
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/product/export-all`, // ✅ เรียกใช้ API Backend ที่เราสร้างขึ้น
                payload,
                {
                    responseType: 'blob', // ✅ สำคัญ: บอกให้ Axios รับข้อมูลเป็น Blob (ไฟล์)
                    timeout: 180000 // ตั้งค่า Timeout ให้สูงพอสำหรับการประมวลผลข้อมูลขนาดใหญ่ (3 นาที)
                }
            );
            // สร้าง Blob จากข้อมูลที่ได้กลับมา
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            console.log("blob", blob);
            // สร้างชื่อไฟล์ที่มี timestamp
            const timestamp = dayjs().format('YYYY-MM-DD_HH-mm-ss');
            saveAs(blob, `รายงานสินค้า_${timestamp}.xlsx`);

        } catch (error) {
            console.error('❌ Export error:', error);
            alert(`ไม่สามารถดาวน์โหลดไฟล์ Excel ได้: ${error?.message || 'Unknown error'}`);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div>
            <div>
                <Button
                    variant='contained'
                    color='success'
                    onClick={handleClick}
                    startIcon={<InsertDriveFileOutlinedIcon />}
                    endIcon={<ArrowDropDownIcon />}
                >
                    <div className='text-white'>ดาวน์โหลดข้อมูลสินค้า</div>
                </Button>

                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem onClick={handleExportListAll}>📥 ดาวน์โหลดข้อมูลสินค้า</MenuItem>
                </Menu>
            </div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
                <p style={{ marginTop: 10 }}>กำลังสร้างรายงาน Excel...</p>
            </Backdrop>
        </div>
    );
};


export default ExelProduct;
